import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input } from '@angular/core';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { filterMediaByLabel } from '@df/ui/common/filter-media-by-label-pipe';
import { ShellComponent } from '@df/ui/common/shell/shell.component';
import { PhotoSwipeModule } from '@df/ui/photoswipe/photoswipe.module';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent } from '@icms/core/content';
import { Nexus } from '@tomandco/nexus-api-types';
import compact from 'lodash-es/compact';
import { AddToBasketComponent } from '../../../basket/add-to-basket';
import { ProductConfigurableOptionsSwatchComponent } from '../../configurable-options/swatch/product-configurable-options-swatch.component';
import { PageComponentCountdownBannerComponent } from '../../countdown-banner/countdown-banner.component';
import { ProductBundleOptionsComponent } from '../../product-bundle-options.component';
import { ProductViewDetailsComponent } from '../details/product-view-details.component';
import { ProductViewLayoutAbstract } from '../layout/product-view-layout.abstract';
import { IMediaRow, IProductViewLayoutContent } from '../layout/product-view-layout.interface';
import { ProductViewMediaItemComponent } from '../media/item/product-view-media-item.component';
import { ProductViewLightboxComponent } from '../media/lightbox/product-view-lightbox.component';
import { ProductViewNameComponent } from '../name/product-view-name.component';
import { ProductViewSidebarComponent } from '../sidebar/product-view-sidebar.component';
import { ProductViewTrayComponent } from '../tray/product-view-tray.component';
import { ProductViewWishlistComponent } from '../wishlist/product-view-wishlist.component';
import { PRODUCT_VIEW_EXTERNAL_CONFIG } from './product-view-external.config';

@Component({
    selector: 'product-view-external',
    templateUrl: './product-view-external.component.html',
    styleUrl: './product-view-external.component.scss',
    standalone: true,
    imports: [
        forwardRef(() => AddToBasketComponent),
        CommonModule,
        GridModule,
        ICmsClientModule,
        PageComponentCountdownBannerComponent,
        PhotoSwipeModule,
        ProductBundleOptionsComponent,
        forwardRef(() => ProductConfigurableOptionsSwatchComponent),
        forwardRef(() => ProductViewDetailsComponent),
        ProductViewLightboxComponent,
        ProductViewMediaItemComponent,
        forwardRef(() => ProductViewNameComponent),
        forwardRef(() => ProductViewSidebarComponent),
        forwardRef(() => ProductViewTrayComponent),
        forwardRef(() => ProductViewWishlistComponent),
        ShellComponent,
        TranslatePipe
    ]
})
@ICmsComponent<ProductViewExternalComponent>(PRODUCT_VIEW_EXTERNAL_CONFIG)
export class ProductViewExternalComponent extends ProductViewLayoutAbstract {
    @ICmsContent({
        type: 'blockContent'
    })
    override content!: IProductViewLayoutContent;

    @Input()
    productLayoutContent?: IProductViewLayoutContent;

    get images(): IMediaRow[] {
        const media = compact([...this.media]);

        if (media.length && media[0].landscape) {
            return [this.getMediaRow(media[0], media, 0, true)];
        }

        return media.map((item): IMediaRow => this.getMediaRow(item, media, 0, false));
    }

    closeExternal(): void {
        this.productView.closeExternal();
    }

    protected override getMedia(): Nexus.Lib.Catalog.Type.IProductMediaItem[] {
        const media = this.product.data?.media || [];

        return (
            filterMediaByLabel(media, ['hero'], false)?.map(item => ({
                ...item,
                landscape: Array.isArray(item.labels) && item.labels.includes('landscape')
            })) || []
        );
    }
}
